import { BranchLocation } from '@model';
import { Events, pubsub } from '@service';
import logger from '@service/logger';
import timeZoneService from '@service/timezone';

export class BranchDefaults {
  static DEFAULT_BRANCH_ID = "173043";
}

export class BranchLocationStore {
  static endpoint =
    'https://building-controls-solutions-default-rtdb.firebaseio.com/locations.json';

  /**
   *
   * @type {SimpleDb}
   */
  db;

  /**
   *
   * @returns {Promise<BranchLocation[]>}
   */
  async fetchRecords() {
    const response = await fetch(BranchLocationStore.endpoint);
    const data = await response.json();
    if (Array.isArray(data)) {
      const records = data.map(it => {
        const branchLocation = BranchLocation.fromJSON(it);
        return branchLocation;
      });
      return records;
    }
    return [];
  }

  /**
   * Query the branch location store for a branch location by zip code.
   * @param {string} zipCode
   * @returns {Promise<BranchLocation>}
   */
  async queryBranchLocationByZipCode(zipCode) {
    return new Promise(async (resolve, reject) => {
      try {
        logger.log(`Searching for branch with zip code: ${zipCode}`);
        const records = await this.fetchRecords();
        const match = records.find(it => it.zip === zipCode);
        if (!!match) {
          logger.log(`Found branch with zip code: ${zipCode}`);
          resolve(match);
        } else {
          logger.log(`Did not find branch with zip code: ${zipCode}`);
          resolve(null);
        }
        if (!!match) {
          // Update its operating hours if possible
          const matchTimeZone = timeZoneService.getTimeZoneForState(match.state);
          if (!!matchTimeZone) {
            const currentTimeInMatchedLocation =
              timeZoneService.getCurrentTimeInTimeZone(matchTimeZone);
            const operatingHours = timeZoneService.getOperatingHoursForTimeZone(matchTimeZone);
            if (2 === operatingHours.length) {
              const [openTime, closeTime] = operatingHours;
              const isClosed =
                currentTimeInMatchedLocation < openTime || currentTimeInMatchedLocation > closeTime;
              match.isClosed = isClosed;
              match.operatingHours.timeZone = matchTimeZone;
              match.operatingHours.open = openTime;
              match.operatingHours.close = closeTime;
            }
          }

          resolve(match);
        } else {
          resolve(null);
        }
      } catch (error) {
        logger.error('Error accessing branch store:', error);
        reject(error);
      }
    });
  }

  async init() {
    pubsub.sub(Events.branchZipCodeCollected, async branchZipCode => {
      const response = await this.queryBranchLocationByZipCode(branchZipCode);
      if (response) {
        pubsub.pub(Events.branchLocationResolved, response);
      }
    });
  }

  constructor() {
    this.init().then(() => {});
  }
}

const branchLocations = new BranchLocationStore();
export default branchLocations;
